import React from 'react';

const SizeModal = ({
  product,
  selectedSize,
  setSelectedSize,
  onCancel,
  onConfirm
}) => {
  if (!product) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
      <div className="bg-white p-6 rounded-lg shadow max-w-sm w-full space-y-4">
        <h3 className="text-lg font-semibold text-center mb-2">Select Size</h3>
        <div className="flex flex-wrap gap-2 justify-center">
          {product.sizes.map((s, idx) => (
            <button
              key={idx}
              onClick={() => setSelectedSize(s.size)}
              className={`px-4 py-2 border rounded text-sm ${
                selectedSize === s.size
                  ? 'bg-black text-white border-black'
                  : 'bg-white border-gray-300 hover:border-black'
              }`}
            >
              {s.size} ({s.stock} in stock)
            </button>
          ))}
        </div>
        <div className="flex justify-between mt-4">
          <button
            onClick={onCancel}
            className="bg-gray-200 px-4 py-2 rounded hover:bg-gray-300"
          >
            Cancel
          </button>
          <button
            disabled={!selectedSize}
            onClick={onConfirm}
            className={`px-4 py-2 rounded text-white ${
              !selectedSize
                ? 'bg-gray-400 cursor-not-allowed'
                : 'bg-blue-600 hover:bg-blue-700'
            }`}
          >
            Add to Cart
          </button>
        </div>
      </div>
    </div>
  );
};

export default SizeModal;
